import styled from "styled-components";

export const Label = styled.label`
  font-size: 14px;
  font-family: Inter;
  color: #000000;
`;
